import uuid from '../../../../utils/uuid.js';
import { BlockBasic } from '../_models/models.js';

export const IconPosition = Object.freeze({
	right: 'right',
	left: 'left'
});

export const ActionTrigger = Object.freeze({
	hover: 'hover',
	click: 'click'
});

export default class BlockFlipCardEnhanced extends BlockBasic {
	constructor(block) {
		super(block);
		if (block) {
			return;
		}

		this.type = 'flipCardEnhanced';
		this.size.width = 700;
		this.size.height = 400;
		this.protection.type = ['flipCardEnhanced'];
		this.data = {
			front: createDefaultFlipCardSide(),
			back: createDefaultFlipCardSide(),
			interactiveBlockIds: [],
			trigger: ActionTrigger.hover
		};
	}
}
function createDefaultFlipCardSide() {
	return {
		id: uuid(),
		blocks: [],
		backgroundColor: '#ffffffff',
		border: {
			color: '#000000ff',
			widthInPx: 1,
			style: 'solid'
		},
		icon: {
			name: 'repeat',
			color: '#000000ff',
			position: IconPosition.right,
			sizeInPx: 40,
			paddingInPx: 4,
			visible: true
		}
	};
}
